/**
 * UC-05 (player start): StartResearchProject
 * Distinct from AdvanceResearchUseCase — player initiates R&D spend and active project.
 */
import { TECH_TREE } from '../../../constants';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type {
  StartResearchProjectInput,
  StartResearchProjectOutput,
} from '../dto/EconomyDto';

export interface StartResearchProjectDependencies {
  logger?: IAppLogger;
}

export class StartResearchProjectUseCase {
  constructor(private readonly deps: StartResearchProjectDependencies = {}) {}

  execute(input: StartResearchProjectInput): StartResearchProjectOutput {
    const { techId, stats, research } = input;
    const tech = TECH_TREE.find((t) => t.id === techId);

    if (!tech) {
      return { ok: false, stats, research, skipped: true };
    }

    if (stats.budget < tech.cost) {
      return {
        ok: false,
        stats,
        research,
        error: 'Insufficient budget for research',
        sfx: 'error',
      };
    }

    const updatedStats = {
      ...stats,
      budget: stats.budget - tech.cost,
    };

    const updatedResearch = {
      ...research,
      activeResearchId: techId,
      researchProgress: 0,
    };

    this.deps.logger?.log('debug', 'research.started', {
      techId,
      techName: tech.name,
      cost: tech.cost,
    });

    return {
      ok: true,
      stats: updatedStats,
      research: updatedResearch,
      newsMessage: `R&D: ${tech.name} started.`,
      newsType: 'neutral',
      sfx: 'click',
    };
  }
}